import { RouteObject } from 'react-router-dom'
import CorrespondenceLogsTable from '../pages/correspondence-logs/CorrespondenceLogsTable'
import { RootState, useAppSelector } from '../utils/agent.store'
import { correspondenceLogsPage } from '../utils/constants'

export const CorrespondenceLogsTableWrapper = ({
  uniqueKey,
  caseId,
  isCaseView = false,
}: {
  uniqueKey: string
  caseId?: string
  isCaseView?: boolean
}) => {
  const selectedClientId = useAppSelector(
    (state: RootState) => state?.authUser?.selectedClientTenant?.id
  )
  return (
    <CorrespondenceLogsTable
      key={selectedClientId}
      uniqueKey={uniqueKey}
      caseId={caseId}
      isCaseView={isCaseView}
    />
  )
}

export const correspondenceLogsRoutes: RouteObject = {
  path: 'correspondence/correspondence-logs',
  handle: {
    crumb: () => 'Logs / Correspondence',
    redirectTo: '/:tenantId/correspondence/correspondence-logs/outbound/:tenantId',
  },
  children: [
    {
      path: 'outbound/:tenantId',
      element: (
        <CorrespondenceLogsTableWrapper
          uniqueKey={correspondenceLogsPage.OUTBOUND_LOWERCASE}
        />
      ),
      handle: {
        crumb: () => 'Outbound',
      },
    },
    {
      path: 'inbound/:tenantId',
      element: (
        <CorrespondenceLogsTableWrapper
          uniqueKey={correspondenceLogsPage.INBOUND_LOWERCASE}
        />
      ),
      handle: {
        crumb: () => 'Inbound Fax',
      },
    },
    {
      path: 'inbound-sms/:tenantId',
      element: (
        <CorrespondenceLogsTableWrapper
          uniqueKey={correspondenceLogsPage.INBOUND_SMS_LOWERCASE}
        />
      ),
      handle: {
        crumb: () => 'Inbound SMS',
      },
    },
    {
      path: 'inbound-web/:tenantId',
      element: (
        <CorrespondenceLogsTableWrapper
          uniqueKey={correspondenceLogsPage.INBOUND_WEB_KEY}
        />
      ),
      handle: {
        crumb: () => 'Inbound Web',
      },
    },
    {
      path: 'inbound-mail/:tenantId',
      element: (
        <CorrespondenceLogsTableWrapper
          uniqueKey={correspondenceLogsPage.INBOUND_MAIL_LOWERCASE}
        />
      ),
      handle: {
        crumb: () => 'Inbound Mail',
      },
    },
  ],
}
